import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import {
  message,
  Input,
  Button,
  Form,
  Space,
  Drawer,
  DatePicker,
  Card,
  Modal,
} from "antd";
import moment from "moment";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Trans, useTranslation } from "react-i18next";
import {
  deleteHistory,
  getPagingHistory,
  deleteManyHistory,
} from "../../helpers/helper";
import DataTable from "../../Components/Common/DataTable";

const { RangePicker } = DatePicker;
const { confirm } = Modal;

const Roles = () => {
  const { t } = useTranslation();
  document.title = t("historyLogin");

  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [listHistory, setListHistory] = useState([]);
  const [visibleForm, setVisibleForm] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");

  //pagination
  const [totalPage, setTotalPage] = useState(1);
  const [indexPage, setPageIndex] = useState(1);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);
  //handle time
  const [dates, setDates] = useState([]);
  const [dateDelete, setDateDelete] = useState([]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingDeleteRows, setLoadingDeleteRows] = useState(false);
  const [isSearch, setIsSearch] = useState(false);

  const getAllData = async (_prams, indexPage) => {
    try {
      const params = _prams
        ? _prams
        : {
            pageIndex: indexPage,
            pageSize: pageSize,
            search: "",
          };
      const dataRes = await getPagingHistory(params);
      setTotalPage(dataRes?.totalPages);
      if (!dataRes) {
        message.error(t("requiredPermission"));
        return false;
      }
      const data =
        dataRes?.data &&
        dataRes?.data.length > 0 &&
        dataRes?.data.map((item) => {
          return {
            key: item._id,
            ip: item.ip,
            fp: item.fp,
            deviceType: item?.deviceType,
            username: item.createdBy?.username,
            createdTime: moment(new Date(item.createdTime)).format(
              "DD/MM/YYYY HH:mm:ss"
            ),
          };
        });
      return dataRes?.data ? data : [];
    } catch (error) {
      message.error(t("requiredPermission"));
      setTotalPage(0);
      return [];
    }
  };

  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      const dataRes = await getAllData(null, indexPage);
      setListHistory(dataRes);
      setLoading(false);
    }
    fetchData();
  }, []);

  const onFinish = async () => {
    formSearch.resetFields();
    form.resetFields();
    handleCloseDrawer();
    handleRefresh();
  };

  const handleRefresh = async () => {
    formSearch.resetFields();
    setDates([]);
    const _params = {
      pageIndex: 1,
      pageSize: 10,
      search: "",
    };
    const dataRes = await getAllData(_params, indexPage);
    setPageIndex(1);
    setListHistory(dataRes);
  };

  const showDrawer = () => {
    setVisibleForm(true);
  };

  const handleDelete = () => {
    setDrawerTitle(t("deleteByTimePeriod"));
    showDrawer();
    form.resetFields();
  };

  const handleSearch = async () => {
    const dataForm = formSearch.getFieldsValue();
    if (!Object.values(dataForm).some((item) => !!item) && dates.length === 0) {
      return;
    }
    setIsSearch(true);
    const params = {
      pageIndex: 1,
      pageSize: pageSize,
      username: dataForm?.userName ? dataForm?.userName.toLowerCase() : "",
      ip: dataForm.ip || "",
      fp: dataForm.fp || "",
      createdTimeStart:
        (dates.length === 2 &&
          moment(dates[0]?._d).utc("+0700").format("YYYY-MM-DD HH:mm")) ||
        "",
      createdTimeEnd:
        (dates.length === 2 &&
          moment(dates[1]?._d).utc("+0700").format("YYYY-MM-DD HH:mm")) ||
        "",
    };
    const dataRes = await getAllData(params, 1);
    setListHistory(dataRes);
    setPageIndex(1);
    setIsSearch(false);
  };

  const onPageChange = (page, page_size) => {
    setPageIndex(page);
    setPageSize(page_size);
    onPageChangeAtSearch(page, page_size);
  };

  const onPageChangeAtSearch = async (indexPage, page_size) => {
    setLoading(true);
    const dataForm = formSearch.getFieldsValue();
    const params = {
      pageIndex: indexPage,
      pageSize: page_size,
      username: dataForm?.userName ? dataForm?.userName.toLowerCase() : "",
      ip: dataForm.ip || "",
      fp: dataForm.fp || "",
      createdTimeStart:
        (dates.length === 2 &&
          moment(dates[0]?._d).utc("+0700").format("YYYY-MM-DD HH:mm")) ||
        "",
      createdTimeEnd:
        (dates.length === 2 &&
          moment(dates[1]?._d).utc("+0700").format("YYYY-MM-DD HH:mm")) ||
        "",
    };
    const dataRes = await getAllData(params, indexPage);
    setListHistory(dataRes);
    setLoading(false);
  };

  const onDelete = async () => {
    try {
      if (dateDelete.length === 2) {
        const timeStart =
          moment(dateDelete[0]._d).utc("+0700").format("YYYY-MM-DD HH:mm") ||
          "";
        const timeEnd =
          moment(dateDelete[1]._d).utc("+0700").format("YYYY-MM-DD HH:mm") ||
          "";

        const data = {
          gte: timeStart,
          lte: timeEnd,
        };
        const dataRes = await deleteHistory(data);
        message.success(
          <Trans
            i18nKey="deleteManyLoginSuccess"
            values={{ count: dataRes.deletedCount }}
          />
        );
        setDateDelete([]);
        setVisibleForm(false);
        handleRefresh();
      } else {
        message.error(t("deleteManyLoginFail"));
      }
    } catch (error) {
      message.error(t("permisstionDeniedAction"));
      setVisibleForm(false);
    }
  };

  const onChangeRangePicker = (value) => {
    if (value?.length === 2) {
      setDates(value);
    } else {
      setDates([]);
    }
  };

  const onChangeRangePickerDelete = (value) => {
    if (value?.length === 2) {
      setDateDelete(value);
    } else {
      setDateDelete([]);
    }
  };

  const showModalConfirmDelete = () => {
    confirm({
      title: t("confirmDelete"),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        onDelete();
      },
      onCancel() {},
    });
  };

  const columns = [
    {
      title: t("userLogin"),
      dataIndex: "username",
    },
    {
      title: t("ip"),
      dataIndex: "ip",
    },
    {
      title: t("fp"),
      dataIndex: "fp",
    },
    {
      title: t("deviceType"),
      dataIndex: "deviceType",
    },
    {
      title: t("createdTime"),
      dataIndex: "createdTime",
    },
  ];

  const onClose = () => {
    setVisibleForm(false);
  };

  const handleCloseDrawer = () => {
    setDrawerTitle("");
    setVisibleForm(false);
    form.resetFields();
  };
  const handleDeleteSelectRows = async () => {
    confirm({
      title: t("confirmDelete"),
      icon: <ExclamationCircleFilled />,
      content: (
        <Trans
          i18nKey="confirmDeleteManyLogin"
          values={{ count: selectedRowKeys.length }}
        />
      ),
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        OnDeleteSelectRows();
      },
      onCancel() {},
    });
  };

  const OnDeleteSelectRows = async () => {
    try {
      setLoadingDeleteRows(true);

      const dataRes = await deleteManyHistory({
        data: { ids: selectedRowKeys },
      });

      dataRes.status === 1
        ? message.success(
            <Trans
              i18nKey="deleteManyLoginSuccess"
              values={{ count: dataRes.deletedCount }}
            />
          )
        : message.error(t("deleteFail"));

      handleRefresh();
      setSelectedRowKeys([]);
      setLoadingDeleteRows(false);
    } catch (error) {
      setLoadingDeleteRows(false);
      message.error(t("permisstionDeniedAction"));
    }
  };
  return (
    <>
      <div className="page-content">
        <div>
          <Col>
            <Drawer
              title={drawerTitle}
              placement={"right"}
              width={"30%"}
              onClose={onClose}
              open={visibleForm}
              bodyStyle={{
                paddingBottom: 80,
              }}
              style={{ marginTop: "70px" }}
            >
              <Form
                form={form}
                layout="vertical"
                onFinish={showModalConfirmDelete}
                autoComplete="off"
              >
                <Row>
                  <Col sm={4} hidden={true}>
                    <Form.Item name="id" label="Id">
                      <Input name="id" />
                    </Form.Item>
                  </Col>
                  <Col className="range-picker">
                    <RangePicker
                      showTime={{ format: "HH:mm" }}
                      format="DD-MM-YYYY HH:mm"
                      value={dateDelete}
                      placeholder={[t("startTime"), t("endTime")]}
                      onChange={onChangeRangePickerDelete}
                    />
                  </Col>
                </Row>
                <Form.Item style={{ paddingTop: "10px" }}>
                  <Space>
                    <Button type="primary" htmlType="submit">
                      {t("confirm")}
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Drawer>
          </Col>
        </div>
        <Card bordered={false}>
          <Row>
            <Col xs={12}>
              <Form
                form={formSearch}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
              >
                <Row>
                  <Col sm={4}>
                    <Form.Item name="userName" label={t("userLogin") + ":"}>
                      <Input
                        placeholder={t("placeHolderUserLogin")}
                        allowClear={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={4}>
                    <Form.Item name="ip" label={t("ip") + ":"}>
                      <Input
                        placeholder={t("placeHolderIp")}
                        allowClear={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={4}>
                    <Form.Item name="fp" label={t("fp") + ":"}>
                      <Input
                        placeholder={t("placeHolderFp")}
                        allowClear={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={4} className="range-picker">
                    <Form.Item label={t("loginTimePeriod") + ":"} />
                    <RangePicker
                      showTime={{ format: "HH:mm" }}
                      format="DD-MM-YYYY HH:mm"
                      value={dates}
                      placeholder={[t("startTime"), t("endTime")]}
                      onChange={onChangeRangePicker}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={4}>
                    <Form.Item label=" ">
                      <Space>
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={() => handleSearch()}
                          loading={isSearch}
                        >
                          {t("search")}
                        </Button>
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={() => handleRefresh()}
                        >
                          {t("reload")}
                        </Button>
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={() => handleDelete()}
                        >
                          {t("deleteByTimePeriod")}
                        </Button>
                        <Button
                          disabled={selectedRowKeys.length === 0}
                          loading={loadingDeleteRows}
                          type="danger"
                          htmlType="button"
                          onClick={() => handleDeleteSelectRows()}
                        >
                          {t("delete")}
                        </Button>
                      </Space>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Card>
        <DataTable
          listData={listHistory}
          pageSize={pageSize}
          columns={columns}
          indexPage={indexPage}
          totalPage={totalPage}
          onPageChange={onPageChange}
          loading={loading}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      </div>
    </>
  );
};
export default Roles;
